var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8712_1533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 59.9637,
    height: 60,
    rx: 29.9819,
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14.5,
    width: 58.9637,
    height: 59,
    rx: 29.4819,
    stroke: "#4D5154"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5404 45.9611C48.4829 45.8204 48.4303 45.6779 48.3815 45.5339C47.0845 41.6803 49.2294 37.5305 53.1726 36.2663L54.3522 34.3155C55.4926 32.4298 54.8518 29.9973 52.9209 28.8817C50.99 27.7662 48.5008 28.3903 47.3605 30.276L46.1808 32.2268C46.2456 32.5595 46.2861 32.8959 46.3036 33.2341C46.5062 37.271 43.3217 40.7015 39.1895 40.8969L31.6499 41.2935C29.0986 40.9539 26.7253 42.63 26.2562 45.1034C26.3422 46.1987 26.9236 47.2009 27.8414 47.8367L30.4424 49.3394L28.3334 52.8269C24.6699 52.3091 21.8776 49.3521 21.6463 45.7424C21.3763 41.5337 24.6488 37.9102 28.9562 37.6497L39.1843 37.1113C40.4027 37.0126 41.4774 36.2972 42.017 35.226C41.562 34.2221 41.6312 33.065 42.2024 32.1204L45.2489 27.0825C47.3662 23.5813 51.9898 22.4213 55.5758 24.4931C59.1617 26.5649 60.3518 31.0827 58.2341 34.5847L55.1875 39.6226C54.6163 40.5672 53.6126 41.1843 52.4934 41.2787C51.7935 42.2573 51.67 43.5231 52.1694 44.6134L52.7256 45.7412L48.5404 45.9611Z",
    fill: "url(#paint0_angular_8712_1533)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0156 42.0408C39.0731 42.1815 39.1257 42.324 39.1744 42.468C40.4715 46.3216 38.3266 50.4713 34.3834 51.7356L33.2037 53.6864C32.0634 55.5721 32.7042 58.0046 34.6351 59.1202C36.566 60.2357 39.0552 59.6116 40.1955 57.7259L41.3752 55.7751C41.3104 55.4424 41.2699 55.1059 41.2524 54.7678C41.0498 50.7308 44.2343 47.3004 48.3665 47.1049L55.9061 46.7084C58.4574 47.048 60.8307 45.3719 61.2997 42.8985C61.2138 41.8032 60.6324 40.801 59.7146 40.1652L57.1136 38.6625L59.2226 35.175C62.8861 35.6928 65.6784 38.6498 65.9097 42.2595C66.1797 46.4682 62.9072 50.0917 58.5998 50.3522L48.3717 50.8906C47.1533 50.9893 46.0786 51.7047 45.539 52.7759C45.994 53.7798 45.9248 54.9369 45.3536 55.8814L42.3071 60.9194C40.1898 64.4206 35.5662 65.5806 31.9802 63.5088C28.3943 61.437 27.2042 56.9192 29.3219 53.4172L32.3685 48.3793C32.9397 47.4347 33.9434 46.8176 35.0626 46.7232C35.7625 45.7446 35.886 44.4787 35.3865 43.3885L34.8304 42.2607L39.0156 42.0408Z",
    fill: "url(#paint1_angular_8712_1533)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1364 28.3499L42.3715 27.0736C40.2669 23.5618 35.6478 22.3789 32.055 24.4324C28.4622 26.4859 27.2551 30.9979 29.3597 34.5098L30.5107 36.4306L34.4184 36.2251L33.2416 34.2613C32.108 32.3701 32.7581 29.9406 34.6925 28.8352C36.6273 27.729 39.1145 28.3661 40.2474 30.2569L41.1129 31.7007C41.1426 31.6468 41.173 31.5934 41.2048 31.5408L43.1354 28.3484L43.1364 28.3499Z",
    fill: "url(#paint2_angular_8712_1533)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.196 53.4895L57.045 51.5686L53.1373 51.7741L54.3141 53.7379C55.4477 55.6291 54.7976 58.0587 52.8632 59.1641C50.9284 60.2702 48.4412 59.6331 47.3083 57.7424L46.4428 56.2986C46.4131 56.3524 46.3827 56.4059 46.3508 56.4585L44.4203 59.6509L45.1852 60.9272C47.2898 64.439 51.9089 65.6219 55.5017 63.5684C59.0945 61.5148 60.3016 57.0028 58.197 53.491L58.196 53.4895Z",
    fill: "url(#paint3_angular_8712_1533)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8712_1533",
    x: 0,
    y: 0,
    width: 87.9639,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.54902 0 0 0 0 0.54902 0 0 0 0 0.54902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8712_1533"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.54902 0 0 0 0 0.54902 0 0 0 0 0.54902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8712_1533",
    result: "effect2_dropShadow_8712_1533"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8712_1533",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_8712_1533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.8639 38.3642) rotate(55.7043) scale(18.0311 23.1195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#447DA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_8712_1533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6921 49.6377) rotate(69.6186) scale(8.6939 6.30248)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006970"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_8712_1533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7275 30.2223) rotate(167.954) scale(8.5461 6.88279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E17900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_8712_1533",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8286 57.7777) rotate(-32.6526) scale(8.64486 7.04746)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB115B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconDark);
export default __webpack_public_path__ + "static/media/menuIconDark.cb5e4d3ea2dbe9979c9080d1c5c19074.svg";
export { ForwardRef as ReactComponent };